import React from 'react';
import { Link } from 'react-router-dom';
import { serviceService } from '../../services/serviceService';

export default class ServiceThree extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            services: [],
            loading: true
        };
    }

    async componentDidMount() {
        try {
            const res = await serviceService.getFeaturedServices();
            if (res.success && Array.isArray(res.data)) {
                this.setState({ services: res.data, loading: false });
            } else {
                this.fallbackServices();
            }
        } catch (error) {
            console.error('Failed to load featured services:', error);
            this.fallbackServices();
        }
    }

    fallbackServices() { this.setState({ services: [], loading: false }); }

    render() {
        let publicUrl = process.env.PUBLIC_URL + '/';
        const { services } = this.state;

        return (
            <>
                <section className="services-three">
                    <div className="shape1"><img src={publicUrl + "assets/images/shapes/services-v3-shape1.png"} alt="#" /></div>
                    <div className="shape2 rotate-me"><img src={publicUrl + "assets/images/update1.0/services-v3-shape2.png"} alt="#" /></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="services-three__top">
                                    <div className="sec-title">
                                        <div className="sec-title__tagline">
                                            <span className="right"></span> <h6>COMPANY SERVICES</h6> <span className="right"></span>
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center w-100'>
                                            <h2 className="sec-title__title">Our Company Best <br /> Services</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            {services.map((service, index) => (
                                <div className="col-xl-3 col-lg-6 col-md-6" key={service.id || index}>
                                    <div className="services-three__single">
                                        <div className="services-three__single__bg" style={{ backgroundImage: 'url(' + publicUrl + 'assets/images/services/services-v1-bg.jpg)' }}></div>
                                        <div className="services-three__single-icon">
                                            <span className={service.icon || 'icon-construction'}></span>
                                        </div>
                                        <h3><Link to={process.env.PUBLIC_URL + `/services`}>{service.title}</Link></h3>
                                        <p>{service.shortDescription || service.description}</p>
                                        <div className="btn-box">
                                            <Link to={process.env.PUBLIC_URL + `/services`}><span className="icon-right-arrow"></span></Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="service-btn d-flex align-items-center justify-content-center">
                            <Link className='btn border p-3 text-white w-auto' id='service-btn' style={{ transition: 'all 0.3s ease' }}
                                to={publicUrl + "services"}>All Services</Link>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}